// src/utils/cloudinary.ts
import axios from 'axios';

export const uploadImage = async (file: File) => {
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME as string;
  const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET as string;
  
  console.log("Cloud Name:", cloudName, "Upload Preset:", uploadPreset);
  console.log("File size:", file.size, "File type:", file.type);

  if (!cloudName || !uploadPreset) {
    throw new Error("Cloudinary configuration missing. Please check environment variables.");
  }

  // Validate file size (max 10MB)
  if (file.size > 10 * 1024 * 1024) {
    throw new Error("File size too large. Maximum size is 10MB.");
  }

  // Validate file type
  if (!file.type.startsWith('image/')) {
    throw new Error("Please select a valid image file.");
  }

  const url = `https://api.cloudinary.com/v1_1/${cloudName}/upload`;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);

  try {
      console.log("Uploading to:", url);
      const response = await axios.post(url, formData, {
          headers: {
              "Content-Type": "multipart/form-data",
          },
          timeout: 30000, // 30 second timeout
      });

      console.log("Upload response:", response.data);
      return response.data.secure_url;
  } catch (error: any) {
      console.error('Detailed upload error:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: {
          url: error.config?.url,
          method: error.config?.method
        }
      });
      
      if (error.response?.status === 400) {
        const errorMessage = error.response?.data?.error?.message || "Invalid upload configuration";
        throw new Error(`Upload failed: ${errorMessage}`);
      }
      
      throw new Error(`Image upload failed: ${error.message}`);
  }
};


  